import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-bold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#3D1D72] disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "bg-[#3D1D72] text-white shadow-md hover:bg-[#2D1556]",
        destructive:
          "bg-[#E63946] text-white shadow-sm hover:bg-[#D32F3D]",
        outline:
          "border-2 border-[#6B7280] bg-white text-[#1F2937] shadow-sm hover:bg-slate-50",
        secondary:
          "bg-[#E5E7EB] text-[#1F2937] shadow-sm hover:bg-[#D1D5DB]",
        ghost: "hover:bg-slate-100 hover:text-[#1F2937]",
        link: "text-[#3D1D72] underline-offset-4 hover:underline",
      },
      size: {
        default: "h-10 px-4 py-2",
        sm: "h-8 rounded-md px-3 text-xs",
        lg: "h-11 rounded-md px-8",
        icon: "h-10 w-10",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
